document.addEventListener("DOMContentLoaded", function () {
  const openBtn   = document.querySelector('#menu_btn_open');
  const closeBtn  = document.querySelector('#menu_btn_close');
  const mobileNav = document.querySelector('#mobile_menu');

  if (openBtn) {
    openBtn.addEventListener('click', () => {
      mobileNav.classList.toggle('hidden');
    });

    closeBtn?.addEventListener('click', () => {
      mobileNav.classList.toggle('hidden');
    });
  }

  // Dropdown toggle logic
  const dropdownButtons = document.querySelectorAll('[data-dropdown]');
  dropdownButtons.forEach(el => {
    el.addEventListener('click', function (e) {
      e.stopPropagation(); // prevent document click from firing
      const targetId = el.dataset.dropdown;
      const targetEl = document.getElementById(targetId);
      if (!targetEl) return;

      document.querySelectorAll('[id^="dropdown-"]').forEach(drop => {
        if (drop !== targetEl) {
          drop.classList.add('hidden');

          // Also remove 'active' class from the corresponding button
          const dropdownId = drop.id;
          const matchingBtn = document.querySelector(`[data-dropdown="${dropdownId}"]`);
          if (matchingBtn?.classList.contains('active')) {
            matchingBtn.classList.remove('active');
          }
        }
      });

      targetEl.classList.toggle('hidden');
      this.classList.toggle('active');
    });
  });

    // Handle drilldown subpanels
  document.querySelectorAll('[data-subpanel]').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();

      const targetId = link.getAttribute('data-subpanel');
      const container = link.closest('[id^="dropdown-"]');
      const mainPanel = container?.querySelector('[id^="main-panel"]');
      const targetPanel = container?.querySelector(`#${targetId}`);

      if (mainPanel && targetPanel) {
        mainPanel.classList.add('hidden');
        targetPanel.classList.remove('hidden');
      }
    });
  });

  // Handle "< Back" link
  document.querySelectorAll('.sub-panel a[href="#"]').forEach(back => {
    back.addEventListener('click', e => {
      e.preventDefault();

      const subPanel = back.closest('.sub-panel');
      const container = subPanel?.closest('[id^="dropdown-"]');
      const mainPanel = container?.querySelector('[id^="main-panel"]');

      subPanel.classList.add('hidden');
      mainPanel.classList.remove('hidden');
    });
  });

  // document.addEventListener('click', function () {
  //   document.querySelectorAll('[id^="dropdown-"]').forEach(drop => {
  //     drop.classList.add('hidden');
  //   });
  //   dropdownButtons.forEach(btn => btn.classList.remove('active'));
  // });



  const filterBtn = document.getElementById('filter_btn');
  const filterBtnTwo = document.getElementById('filter_btn_two');
  const hidePopup = document.getElementById('hide_popup');
  const filterPopup = document.getElementById('filter_popup');
  let resizeTimeout;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);

    resizeTimeout = setTimeout(() => {
      const isDesktop = window.innerWidth >= 1024;
      const htmlHasOverflowHidden = document.documentElement.style.overflow === 'hidden';

      if (isDesktop && htmlHasOverflowHidden) {
        const filterPopup = document.getElementById('filter_popup');

        if (filterPopup) {
          filterPopup.classList.add('hidden');
          filterPopup.style.overflow = 'initial';
        }

        document.documentElement.style.overflow = '';
      }

      // Close all dropdowns
      document.querySelectorAll('[id^="dropdown-"]').forEach(drop => {
        drop.classList.add('hidden');
      });

      // Remove 'active' from all dropdown buttons
      const dropdownButtons = document.querySelectorAll('.dropdown-toggle, .dropdown-button');
      dropdownButtons.forEach(btn => btn.classList.remove('active'));
    }, 150);
  });

  if (filterBtn && filterPopup) {
    filterBtn.addEventListener('click', () => {
      filterPopup.classList.remove('hidden');
      filterPopup.style.overflow = 'scroll';
      document.documentElement.style.overflow = 'hidden'; 
    });
  }

  if (filterBtnTwo && filterPopup) {
    filterBtnTwo.addEventListener('click', () => {
      filterPopup.classList.toggle('hidden');

      const span = filterBtnTwo.querySelector('span');

      if (filterPopup.classList.contains('hidden')) {
        span.innerHTML = 'Filters & Sort';
      } else {
        span.innerHTML = 'Close Filters & Sort';
      }
    });
  }

  if (hidePopup && filterPopup) {
    hidePopup.addEventListener('click', (event) => {
      event.preventDefault();
      filterPopup.classList.add('hidden');
      filterPopup.style.overflow = 'initial';
      document.documentElement.style.overflow = 'initial'; 
    });
  }

  // for mobile menu
    const mainPanelId = 'mobile-menu-panel-main';

    // Handle opening target panels
    document.querySelectorAll('[data-panel-target]').forEach(button => {
        button.addEventListener('click', () => {
            const targetId = button.getAttribute('data-panel-target');
            const targetPanel = document.getElementById('mobile-menu-panel-' + targetId);

            // Hide all panels
            document.querySelectorAll('[id^="mobile-menu-panel-"]').forEach(panel => {
                panel.classList.add('hidden');
            });

            // Show target panel
            if (targetPanel) {
                targetPanel.classList.remove('hidden');
            }
        });
    });

    // Handle back buttons
    document.querySelectorAll('[data-panel-back]').forEach(button => {
        button.addEventListener('click', () => {
            // Hide current panel
            const currentPanel = button.closest('[id^="mobile-menu-panel-"]');
            if (currentPanel) {
                currentPanel.classList.add('hidden');
            }

            // Show previous panel – fallback to main
            const previousPanel = currentPanel?.dataset?.parentPanel
                ? document.getElementById(currentPanel.dataset.parentPanel)
                : document.getElementById(mainPanelId);

            if (previousPanel) {
                previousPanel.classList.remove('hidden');
            }
        });
    });

    // Close menu
    document.getElementById('menu_btn_close')?.addEventListener('click', () => {
        document.getElementById('mobile_menu')?.classList.add('hidden');
        document.querySelectorAll('[id^="mobile-menu-panel-"]').forEach(panel => {
            panel.classList.add('hidden');
        });
        document.getElementById(mainPanelId)?.classList.remove('hidden');
    });

    // close nav when cliking away
    document.addEventListener('click', function (e) {

      if (window.innerWidth < 1024) return;

      const clickedToggle = e.target.closest('[data-dropdown]');
      const insideDropdown = e.target.closest('[id^="dropdown-"]');

      if (clickedToggle || insideDropdown) return;

      document.querySelectorAll('[id^="dropdown-"]').forEach(drop => {
        if (!drop.classList.contains('hidden')) {
          drop.classList.add('hidden');
          const matchingBtn = document.querySelector(`[data-dropdown="${drop.id}"]`);
          matchingBtn?.classList.remove('active');
        }
      });
    });


    document.querySelectorAll('a[href^="tel:"]').forEach(link => {
      link.addEventListener('click', (e) => {
        // allow tracking to run first
        setTimeout(() => {
          window.location.href = link.getAttribute('href');
        }, 200);
      });
    });
      
});



document.addEventListener('DOMContentLoaded', function () {
    const toggleButton = document.querySelector('[data-mobile-nav-toggle]');
    const sharedNav = document.querySelector('[data-shared-nav]');
    const openIcon = document.querySelector('[data-mobile-icon-open]');
    const closeIcon = document.querySelector('[data-mobile-icon-close]');
    const mobileLabel = document.querySelector('[data-mobile-label]');
    const desktopTriggers = document.querySelectorAll('[data-desktop-menu]');
    const dropdowns = document.querySelectorAll('[data-dropdown]');
    const priceSwitchForms = document.querySelectorAll('[data-price-switch-form]');
    const desktopBreakpoint = window.matchMedia('(min-width: 1024px)');
    const stickyHeaderBar = document.querySelector('[data-site-header] > .sticky');

    if (!toggleButton || !sharedNav) {
        return;
    }

    function closeAllDropdowns() {
        dropdowns.forEach(function (dropdown) {
            dropdown.classList.add('hidden');
            dropdown.style.position = '';
            dropdown.style.top = '';
            dropdown.style.left = '';
            dropdown.style.width = '';
            dropdown.style.zIndex = '';
            dropdown.style.display = '';
        });

        desktopTriggers.forEach(function (trigger) {
            trigger.classList.remove('nav-active');
            trigger.setAttribute('aria-expanded', 'false');
        });
    }

    function positionDesktopDropdown(dropdown) {
        if (!stickyHeaderBar) {
            return;
        }

        const stickyRect = stickyHeaderBar.getBoundingClientRect();
        dropdown.style.position = 'fixed';
        dropdown.style.top = stickyRect.bottom + 'px';
        dropdown.style.left = '0';
        dropdown.style.width = '100%';
        dropdown.style.zIndex = '99999';
    }

    function openDropdown(name, mobileMode) {
        const dropdown = document.querySelector('[data-dropdown="' + name + '"]');
        const trigger = document.querySelector('[data-desktop-menu="' + name + '"]');

        if (!dropdown) {
            return;
        }

        closeAllDropdowns();

        dropdown.classList.remove('hidden');
        dropdown.style.display = 'block';

        if (mobileMode) {
            dropdown.style.position = 'absolute';
            dropdown.style.top = '107px';
            dropdown.style.left = '0';
            dropdown.style.width = '100%';
            dropdown.style.zIndex = '99999';
        } else {
            positionDesktopDropdown(dropdown);
        }

        if (trigger) {
            trigger.classList.add('nav-active');
            trigger.setAttribute('aria-expanded', 'true');
        }
    }

    function setDesktopNav() {
        sharedNav.className = 'hidden w-full lg:flex lg:w-auto items-stretch';

        sharedNav.querySelectorAll(':scope > a').forEach(function (link) {
            link.classList.remove('min-h-[58px]', 'justify-between', 'px-4');
            link.classList.add('h-[70px]', 'px-5');
        });

        toggleButton.setAttribute('aria-expanded', 'false');
        toggleButton.classList.remove('is-open');

        if (openIcon) openIcon.classList.remove('hidden');
        if (closeIcon) closeIcon.classList.add('hidden');
        if (mobileLabel) mobileLabel.textContent = 'Menu';

        document.body.classList.remove('mobile-menu-open');
        closeAllDropdowns();
    }

    function openMobileMenu() {
        window.scrollTo(0, 0);

        sharedNav.className = 'flex w-full flex-col items-stretch';

        sharedNav.querySelectorAll(':scope > a').forEach(function (link) {
            link.classList.remove('h-[70px]', 'px-5');
            link.classList.add('min-h-[58px]', 'justify-between', 'px-4');
        });

        toggleButton.setAttribute('aria-expanded', 'true');
        toggleButton.classList.add('is-open');

        if (openIcon) openIcon.classList.add('hidden');
        if (closeIcon) closeIcon.classList.remove('hidden');
        if (mobileLabel) mobileLabel.textContent = 'Close';

        document.body.classList.add('mobile-menu-open');
        closeAllDropdowns();
    }

    function closeMobileMenu() {
        sharedNav.className = 'hidden w-full lg:flex lg:w-auto items-stretch';

        sharedNav.querySelectorAll(':scope > a').forEach(function (link) {
            link.classList.remove('min-h-[58px]', 'justify-between', 'px-4');
            link.classList.add('h-[70px]', 'px-5');
        });

        toggleButton.setAttribute('aria-expanded', 'false');
        toggleButton.classList.remove('is-open');

        if (openIcon) openIcon.classList.remove('hidden');
        if (closeIcon) closeIcon.classList.add('hidden');
        if (mobileLabel) mobileLabel.textContent = 'Menu';

        document.body.classList.remove('mobile-menu-open');
        closeAllDropdowns();
    }

    function isMobileOpen() {
        return toggleButton.getAttribute('aria-expanded') === 'true';
    }

    desktopTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
            const name = trigger.getAttribute('data-desktop-menu');
            const dropdown = document.querySelector('[data-dropdown="' + name + '"]');
            const isDesktop = window.innerWidth >= 1024;

            if (!dropdown) {
                return;
            }

            event.preventDefault();

            const isAlreadyVisible = !dropdown.classList.contains('hidden');

            if (isDesktop) {
                if (isAlreadyVisible) {
                    closeAllDropdowns();
                } else {
                    openDropdown(name, false);
                }
                return;
            }

            if (!isMobileOpen()) {
                openMobileMenu();
            }

            if (isAlreadyVisible) {
                closeAllDropdowns();
            } else {
                openDropdown(name, true);
            }
        });
    });

    toggleButton.addEventListener('click', function () {
        if (window.innerWidth >= 1024) {
            return;
        }

        if (isMobileOpen()) {
            closeMobileMenu();
        } else {
            openMobileMenu();
        }
    });

    document.addEventListener('click', function (event) {
        const clickedTrigger = event.target.closest('[data-desktop-menu]');
        const clickedDropdown = event.target.closest('[data-dropdown]');
        const clickedToggle = event.target.closest('[data-mobile-nav-toggle]');

        if (!clickedTrigger && !clickedDropdown && !clickedToggle) {
            closeAllDropdowns();

            if (window.innerWidth < 1024) {
                closeMobileMenu();
            }
        }
    });

    window.addEventListener('scroll', function () {
        if (window.innerWidth < 1024) {
            return;
        }

        dropdowns.forEach(function (dropdown) {
            if (!dropdown.classList.contains('hidden')) {
                positionDesktopDropdown(dropdown);
            }
        });
    }, { passive: true });

    desktopBreakpoint.addEventListener('change', function (event) {
        if (event.matches) {
            setDesktopNav();
        } else {
            closeMobileMenu();
        }
    });

    priceSwitchForms.forEach(function (form) {
        const hiddenInput = form.querySelector('[data-price-switch-input]');
        const toggleInputs = form.querySelectorAll('input[type="radio"]');

        if (!hiddenInput || !toggleInputs.length) {
            return;
        }

        toggleInputs.forEach(function (input) {
            input.addEventListener('change', function () {
                hiddenInput.value = input.value;
                // form.submit(); 
            });
        });
    });

    setDesktopNav();
});
